import { StandardEvents } from '@shopify/events';
import { ThemeEvents } from '@theme/events';

class AuranOffer extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.addEventListener('click', this.copyCode, options);
    if (this.dataset.context === 'cart' || !this.dataset.productId) return;
    this.section = this.closest('.shopify-section');
    this.section?.addEventListener(StandardEvents.productSelect, this.selectVariant, options);
    this.section?.addEventListener('change', this.changeQuantity, { ...options, capture: true });
    this.section?.addEventListener('input', this.changeQuantity, { ...options, capture: true });
    this.section?.addEventListener(ThemeEvents.quantitySelectorUpdate, this.changeQuantity, options);
  }
  disconnectedCallback() {
    this.controller?.abort();
    clearTimeout(this.resetTimer);
    this.selectionVersion = (this.selectionVersion || 0) + 1;
  }
  copyCode = async (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-offer-code]');
    if (!(button instanceof HTMLButtonElement) || !this.contains(button)) return;
    const status = this.querySelector('[role="status"]');
    const code = button.dataset.offerCode;
    if (!status || !code) return;
    clearTimeout(this.resetTimer);
    button.disabled = true;
    try {
      await navigator.clipboard.writeText(code);
      if (!this.isConnected) return;
      status.textContent = code + ' ' + this.dataset.success;
    } catch {
      if (!this.isConnected) return;
      status.textContent = this.dataset.failure + ' ' + code;
    } finally {
      button.disabled = false;
    }
    this.resetTimer = setTimeout(() => { status.textContent = ''; }, 5000);
  };
  selectVariant = async (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const version = this.selectionVersion = (this.selectionVersion || 0) + 1;
    try {
      const result = await event.promise;
      if (!this.isConnected || version !== this.selectionVersion) return;
      if (!result.variant || result.detail?.newProduct) return;
      const price = Number(result.variant.price.amount);
      if (!Number.isFinite(price)) return;
      this.dataset.price = String(Math.round(price * 100));
      this.updateEstimate();
    } catch {}
  };
  changeQuantity = (event) => {
    if (event.type === ThemeEvents.quantitySelectorUpdate || event.target instanceof HTMLInputElement && event.target.name === 'quantity') this.updateEstimate();
  };
  updateEstimate() {
    const input = this.section?.querySelector('input[name="quantity"]');
    const quantity = input instanceof HTMLInputElement ? Math.max(1, Number(input.value) || 1) : 1;
    const price = Number(this.dataset.price) * quantity;
    const rate = price >= Number(this.getAttribute('data-minimum-28')) ? 28 : price >= Number(this.getAttribute('data-minimum-25')) ? 25 : 22;
    const button = this.querySelector('[data-offer-rate="' + rate + '"]');
    const value = this.querySelector('[data-offer-price]');
    const codeLabel = this.querySelector('[data-offer-price-code]');
    if (!button || !value || !codeLabel || !Number.isFinite(price)) return;
    const cents = Math.round(price * (100 - rate) / 100);
    value.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: this.dataset.currency || 'USD'
    }).format(cents / 100);
    codeLabel.textContent = this.dataset.codeLabel + ' ' + button.dataset.offerCode;
    for (const tier of this.querySelectorAll('[data-offer-tier]')) tier.toggleAttribute('data-current', Number(tier.dataset.offerTier) === rate);
  }
}
if (!customElements.get('auran-offer')) customElements.define('auran-offer', AuranOffer);

